/**
 * Who a text or a call is from: the card stores' `currentProvider`, which the
 * compose modals show on their "From" line and send as a call's `from`.
 *
 * While a staff member charts a patient, pacmny-be puts the PATIENT in
 * `allData.patient` and the staff member in `allData.manager`
 * (DataManagerImpl::getAllData), and says so with `viewingPatientChart`. The
 * stores mapped `allData.patient`, so the modals offered the patient's phone
 * as the caller's own. `viewingPatientChart` is read rather than the presence
 * of `manager`: a cached session can still carry a manager from an earlier
 * visit.
 *
 * Prefer MySQL sessionSelf (GetSelfProfile) for name / phone / email when
 * loaded; otherwise the PHR manager-vs-patient heuristic above.
 *
 * keyon chooses the number a call is actually bridged to from its own record
 * of the caller (keyon/lib/TwilioAccess.php); this is the number the caller
 * sees and asks for. `id` and `specialty` stay what the stores always had -
 * AppointmentModule seeds a provider id from `id`, and `manager` carries
 * neither. (While charting, id stays the chart patient's externid.)
 *
 * @param {object} allData Vuex login/getAllData
 * @param {object|null|undefined} sessionSelf optional; undefined peeks Pinia
 * @returns {{id: string, name: string, email: string, phone: string, specialty: string}}
 */
import { sessionActorFrom } from '@/utils/sessionIdentity';
import { peekSessionSelfProfile } from '@/stores/sessionSelf';

export function messagingSender(allData, sessionSelf) {
  const patient = allData && allData.patient;
  if (!patient) {
    throw new Error('No provider data available');
  }
  const sender = {
    id: patient.externid || '',
    name: [patient.firstName, patient.lastName].filter(Boolean).join(' ') || 'Unknown',
    email: patient.email || '',
    phone: patient.phone1 || patient.phone2 || '',
    specialty: patient.specialty || 'N/A',
  };
  const manager = allData.manager;
  if (allData.viewingPatientChart && manager) {
    sender.name = manager.name || sender.name;
    sender.phone = manager.phone1 || manager.phone2 || '';
    // pacmny-be's manager block carries no email today, so this is usually
    // empty; the modals then show the name alone rather than the patient's
    // address beside it. keyon ignores the posted fromEmail.
    sender.email = manager.email || '';
  }

  const actor = sessionActorFrom(allData, peekSessionSelfProfile(sessionSelf));
  if (actor.source === 'mysql') {
    sender.name = actor.displayName || sender.name;
    sender.phone = actor.phone1 || '';
    sender.email = actor.email || '';
    if (!allData.viewingPatientChart) {
      sender.id = actor.unique_ID || sender.id;
    }
  }
  return sender;
}
